import { useMount } from '@contra/react-hooks/useMount';
import { useState } from 'react';

export const useBrowserVisibility = () => {
  const [isVisible, setIsVisible] = useState(true);

  useMount(() => {
    const handleVisibilityChange = () => {
      setIsVisible(!document.hidden);
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Clean up the event listener on component unmount
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  });

  return { isVisible };
};
